import { TFunction } from "next-i18next";
import * as Yup from "yup";

import { RECOVER_PASSWORD_FIELDS } from "./constants";

export const getForgotPasswordValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    email: Yup.string()
      .max(100, t("password_recovery-validation_messages-email_exceeds_maximum_length"))
      .required(t("password_recovery-validation_messages-email_is_required")),
  });

export const getRecoverPasswordValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    [RECOVER_PASSWORD_FIELDS.PASSWORD]: Yup.string()
      .max(128, t("password_recovery-validation_messages-password_exceeds_maximum_length"))
      .required(t("password_recovery-validation_messages-password_is_required")),
    [RECOVER_PASSWORD_FIELDS.PASSWORD_REPEAT]: Yup.string()
      .max(128, t("password_recovery-validation_messages-password_exceeds_maximum_length"))
      .oneOf(
        [Yup.ref(RECOVER_PASSWORD_FIELDS.PASSWORD), undefined],
        t("password_recovery-validation_messages-passwords_must_match")
      )
      .required(t("password_recovery-validation_messages-password_is_required")),
  });
